import React from 'react';
import Icon from '../../../components/AppIcon';

const SubscriptionLifecyclePanel = ({ invoices }) => {
  const calculateChurnRate = () => {
    // Calculate churn rate based on invoice data
    return '2.3%';
  };

  const getUpgradeDowngradeStats = () => {
    // Analyze tier changes from invoice history
    return {
      upgrades: 5,
      downgrades: 2,
      cancellations: 1
    };
  };

  const stats = getUpgradeDowngradeStats();

  return (
    <div className="space-y-6">
      {/* Lifecycle Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-success/5 rounded-lg p-4 border border-success/20">
          <div className="flex items-center justify-between mb-2">
            <Icon name="TrendingUp" size={20} className="text-success" />
            <span className="text-2xl font-bold text-foreground">{stats?.upgrades}</span>
          </div>
          <h3 className="text-sm font-medium text-foreground mb-1">Upgrades</h3>
          <p className="text-xs text-muted-foreground">Last 30 days</p>
        </div>

        <div className="bg-warning/5 rounded-lg p-4 border border-warning/20">
          <div className="flex items-center justify-between mb-2">
            <Icon name="TrendingDown" size={20} className="text-warning" />
            <span className="text-2xl font-bold text-foreground">{stats?.downgrades}</span>
          </div>
          <h3 className="text-sm font-medium text-foreground mb-1">Downgrades</h3>
          <p className="text-xs text-muted-foreground">Last 30 days</p>
        </div>

        <div className="bg-error/5 rounded-lg p-4 border border-error/20">
          <div className="flex items-center justify-between mb-2">
            <Icon name="XCircle" size={20} className="text-error" />
            <span className="text-2xl font-bold text-foreground">{stats?.cancellations}</span>
          </div>
          <h3 className="text-sm font-medium text-foreground mb-1">Cancellations</h3>
          <p className="text-xs text-muted-foreground">Last 30 days</p>
        </div>
      </div>

      {/* Renewal Calendar */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-bold text-foreground mb-4">Upcoming Renewals</h3>
        <div className="space-y-3">
          {invoices?.slice(0, 5)?.map((invoice, index) => (
            <div key={invoice?.id} className="flex items-center justify-between py-3 border-b border-border last:border-0">
              <div className="flex items-center gap-3">
                <div className="bg-primary/10 rounded-full p-2">
                  <Icon name="Calendar" size={16} className="text-primary" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">
                    Client #{invoice?.id?.slice(0, 8)?.toUpperCase()}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {invoice?.tierAtBilling} - {invoice?.employeeCountAtBilling} employees
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-foreground">
                  K{parseFloat(invoice?.amountKina || 0)?.toFixed(2)}
                </p>
                <p className="text-xs text-muted-foreground">
                  {new Date(invoice?.billingDate)?.toLocaleDateString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Churn Prevention */}
      <div className="bg-warning/5 rounded-lg border border-warning/20 p-6">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={20} className="text-warning mt-0.5" />
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Churn Risk Analysis</h3>
            <p className="text-sm text-muted-foreground mb-3">
              Current churn rate: <span className="font-semibold">{calculateChurnRate()}</span>
            </p>
            <p className="text-xs text-muted-foreground">
              Predictive analytics identify 3 clients at risk of cancellation. Proactive engagement recommended.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionLifecyclePanel;